import type { TFunction } from 'i18next';
import { hora, data as fmtData, nomePessoa, textoLivre } from '../../nucleo/formato';
import type { ParametrosSistema, UltimaMensagem } from './tipos';

const MODELOS = new Set(['criou', 'entrou', 'saiu', 'adicionou', 'removeu', 'renomeou', 'publico', 'privado', 'arquivou', 'desarquivou', 'promoveu', 'rebaixou', 'discussao']);

/**
 * Mensagem de sistema do canal no idioma do app, montada dos parâmetros (o servidor grava a frase em pt). Fase 2 (W20): no chat
 * da equipe, o nome das pessoas (quem fez e quem foi alvo) passa pelo modo discreto (`nomePessoa`); o nome do canal é texto
 * livre e passa pela censura com os nomes das pessoas do chat.
 */
export function textoDoSistema(t: TFunction, parametros: ParametrosSistema | null | undefined, textoPt: string, nomes: readonly (string | null | undefined)[] = []): string {
  const modelo = parametros?.modelo;
  if (!modelo || !MODELOS.has(modelo)) return textoLivre(textoPt, ...nomes, parametros?.ator, ...(parametros?.alvos ?? []));
  return t(`sistema.${modelo}`, { ator: nomePessoa(parametros?.ator), alvos: (parametros?.alvos ?? []).map((a) => nomePessoa(a)).join(', '), nome: textoLivre(parametros?.nome ?? '', ...nomes) });
}

/**
 * Prévia da última mensagem na lista: autor (ou "Você"), texto em uma linha, anexos ou "mensagem apagada". W20: o autor
 * passa por `nomePessoa` e o texto pela censura com os nomes das pessoas do chat (a menção "@Nome" vira as iniciais).
 */
export function previaDaUltima(t: TFunction, u: UltimaMensagem | null, eu: string, mostrarAutor: boolean, nomes: readonly (string | null | undefined)[] = []): string {
  if (!u) return t('lista.semMensagens');
  if (u.apagada) return t('lista.apagada');
  if (u.tipo === 'sistema') return textoDoSistema(t, u.parametros, u.texto, nomes);
  const corpo = u.texto ? textoLivre(u.texto, ...nomes, u.autor_nome).replace(/\s+/g, ' ').trim() : t('lista.anexo', { count: u.anexos });
  if (!mostrarAutor && u.autor_id !== eu) return corpo;
  const autor = u.autor_id === eu ? t('lista.voce') : nomePessoa(u.autor_nome);
  return autor ? `${autor}: ${corpo}` : corpo;
}

/** Hora (hoje) ou data (outros dias), no idioma do app. */
export function quando(v: string | null | undefined): string {
  if (!v) return '';
  const d = new Date(v);
  return d.toDateString() === new Date().toDateString() ? hora(d) : fmtData(d);
}
